import {FactoryID} from "../type-interface/ModelFactoryType";
import {cloneObjectTo} from "../../common/SiteHelper";
import {IFactoryData} from "./ModelFactoryInterface";

export default class ModelFactoryChoice implements IFactoryData
{
    id:string;
    factoryID:FactoryID = "none";

    name: string = "";

    constructor(id?:string)
    {
        this.id = id ? id : "";
    }

    clone(cloneTo?:ModelFactoryChoice):ModelFactoryChoice
    {
        const clone: ModelFactoryChoice = cloneTo ? cloneTo : new ModelFactoryChoice(this.id);

        cloneObjectTo(this, clone, true);

        return  clone;
    }
}

export interface IModelFactoryChoices
{
    [key: string]: ModelFactoryChoice;
}